"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwisterbandMath = void 0;
/**
 * Formulas related to Twisterband Ketten
 */
class TwisterbandMath {
    /**
     * Calculates the length of a twisterband kette.
     *
     * @param aeussererLeitungsbauraum_mm AeussererLeitungsbauraum of the Kette
     * @param bandwinkel_deg Bandwinkel of the Kette
     * @param anzahlBaender The amount of Baender of the Kette
     * @returns The cable length for a Twisterband Kette
     */
    static calcLaenge_mm(aeussererLeitungsbauraum_mm, bandwinkel_deg, anzahlBaender) {
        return Math.PI * aeussererLeitungsbauraum_mm * (bandwinkel_deg / 360) * anzahlBaender;
    }
    /**
     * Calculates the amount of a twisterband chain links.
     *
     * @param anzahlBaender The amount of Baender of the Kette
     * @param oeffnungsstegeProBand The amount of Oeffnungsstege per Band
     * @returns amount of a twisterband chain links.
     */
    static calcNumGlider(anzahlBaender, oeffnungsstegeProBand) {
        return anzahlBaender * oeffnungsstegeProBand;
    }
}
exports.TwisterbandMath = TwisterbandMath;
//# sourceMappingURL=twisterband-math.js.map